import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./Compoemnt/Navbar";
import Footer from "./Compoemnt/Footer";

import Home from "./Pages/Home";
import About from "./Pages/About";
import Services from "./Pages/Services";
import Contact from "./Pages/Contact";
import Terms from "./Pages/Terms";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import RefundPolicy from "./Pages/RefundPolicy";
import Disclaimer from "./Pages/Disclaimer";
import UserPolicies from "./Pages/UserPolicy";

function App() {
  return (
    <Router>
      <div className="flex flex-col min-h-screen">
        {/* Common Navbar */}
        <Navbar />

        {/* Page Content */}
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/products" element={<Services />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacypolicy" element={<PrivacyPolicy />} />
            <Route path="/refundpolicy" element={<RefundPolicy />} />
            <Route path="/disclaimer" element={<Disclaimer />} />
            <Route path="/userpolicy" element={<UserPolicies />} />
          </Routes>
        </main>

        {/* Common Footer */}
        <Footer />
      </div>
    </Router>
  );
}

export default App;
